import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorage, Modules } from 'src/app/appCommon/Enums/enum';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { CrossTabService } from 'src/app/appServices/CrossTabService/crossTab.service';
import { DataService } from 'src/app/appServices/DataService/data.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  error: any = '';
  form: any = {
    username: null,
    password: null,
  };
  isLoggedIn = false;
  isLoginFailed = false;
  roles: string[] = [];
  decryptUserName: any;
  decryptRoleId: any;
  decryptRoleName: any;
  encryptedRoleName: any;
  isProductionEnvrionment: boolean = false;
  IsDirectLogin: boolean = false;
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private helperService: HelperService,
    private dataService: DataService
  ) { }
  ngOnInit(): void {
    const RoleName = this.helperService.decryption(localStorage.getItem(this.dataService.gettingLocalStorageKeys(LocalStorage.UserRoleName)));
    const UId = this.helperService.decryption(localStorage.getItem(this.dataService.gettingLocalStorageKeys(LocalStorage.UId)));
    const UName = this.helperService.decryption(localStorage.getItem(this.dataService.gettingLocalStorageKeys(LocalStorage.UName)));
    this.isProductionEnvrionment = environment.production;
    this.route.queryParams.subscribe((queryparam) => {
      if (queryparam['tun'] != undefined && queryparam['tri'] != undefined) {
        this.IsDirectLogin = true;
        this.decryptUserName = this.helperService.decryption(queryparam['tun']);
        this.decryptRoleId = this.helperService.decryption(queryparam['tri']);
        this.decryptRoleName = this.helperService.decryption(queryparam['trn']);

        if (  UName === this.decryptUserName &&
          UId === this.decryptRoleId &&
          RoleName === this.decryptRoleName &&
          !this.authService.isTokenExpired()) {
          this.router.navigate(['/Dashboard']);
        }
        else {
          this.proceedForLogin();
        }
      }
      else if (this.authService.isTokenExpired() === false) {
        this.router.navigate(['/Dashboard']);
      }
      else {
        if (this.isProductionEnvrionment) {
          window.open(environment.teleUrl, "_self");
        }
      }
    });
  }

  proceedForLogin(): void {
    try {
      if (!localStorage.getItem("token") && !localStorage.getItem("tokenExpiry") && !localStorage.getItem("isLogin")) {
        window.localStorage.clear();
      }
      let _env = this.helperService.ecryption(JSON.stringify(environment.production))
      this.authService.login(this.decryptUserName, this.decryptRoleId, this.decryptRoleName, _env);
    }
    catch (err) {
      this.error = err
    }
  }

  reloadPage(): void {
    window.location.reload();
  }

  getParamsToURL() {
    var encryptName = this.helperService.ecryption('nmowzoon@tstelemed.com');
    var roleId = this.helperService.ecryption('7067A8A4-C442-4C2D-ADEB-3F50095248DB'); // super admin
    var roleName = this.helperService.ecryption('superadmin');
    this.router.navigate([Modules.Login], { queryParams: { tun: encryptName, tri: roleId, trn: roleName  }, queryParamsHandling: 'merge' });
  }
}

